import dynamic from "next/dynamic";
import PropertyLocationMessage from "@template/Search/PropertyLocationMessage";
import { PropertiesTestInterface } from "commonModule/services/search";
import DownArrowIcon from "components/icons-svg/DownArrow";
import PriceDropsAlertsSection from "components/pages/vacation-rentals/PriceDropsAlerts/price-drops-alerts-section";
import { MAP_AREA } from "constant";
import useSearchListingPropertiesCount from "hooks/swr/useSearchListingPropertiesCount";
import { useIsAgent } from "hooks/useIsAgent";
import { useAppSelector } from "stores/hooks";
import { selectIsBoundaryAutoRemoved, selectNearByProperties, selectSearchQuery } from "stores/search/searchSlice";
const SortButton = dynamic(() => import( /* webpackChunkName: "SortButton" */"components/pages/vacation-rentals/SortButton"), {
  ssr: false,
  loading: () => <button className={`btn inline-flex h-9 w-full min-w-[auto] items-center whitespace-nowrap rounded-[31px] border border-[#BCC1D6] bg-white !px-3 py-2 text-sm font-medium text-Gray-700 lg2:w-[auto]`} data-nosnippet>
        <p className='text-xs leading-5'>
          <span className='hidden lg2:inline'> Sort by: </span>
          <span className='font-bold'>Price: high to low</span>
        </p>
        <DownArrowIcon className='ml-1 h-5 w-5' />
      </button>
});
const SearchResultMessageAndSortFilter = ({
  isTheseNearByProperties,
  isPropertiesLoading,
  locationName,
  hasPolygonData,
  propertyData,
  mutate
}: {
  isTheseNearByProperties: boolean;
  isPropertiesLoading: boolean;
  locationName: string | undefined;
  hasPolygonData: boolean;
  propertyData?: PropertiesTestInterface;
  mutate?: () => void;
}) => {
  const countApiResponse = useSearchListingPropertiesCount();
  const count = countApiResponse?.data?.originalCount || countApiResponse?.data?.count;
  const isBoundaryAutoRemoved = useAppSelector(selectIsBoundaryAutoRemoved);
  const searchQuery = useAppSelector(selectSearchQuery);
  const isSearchingNearbyProperties = useAppSelector(selectNearByProperties);
  const isAgent = useIsAgent();
  const isShowPriceDropsAlerts = searchQuery?.name && searchQuery?.startDate && searchQuery?.endDate && !searchQuery?.isSearchingInMap && (!isSearchingNearbyProperties || propertyData?.showPDAToggle) && propertyData?.content && propertyData?.content.length !== 0 && !isAgent;
  return <>
      <div className='disable_click mt-0 flex flex-wrap items-center justify-between gap-1 ssm2:gap-2.5 md:mt-4'>
        <PropertyLocationMessage propertyData={propertyData?.content} locationName={locationName} isTheseNearByProperties={isTheseNearByProperties} isPropertiesLoading={isPropertiesLoading} data-sentry-element="PropertyLocationMessage" data-sentry-source-file="SearchResultMessageAndSortFilter.tsx" />

        {/* price drops alerts section */}
        {isShowPriceDropsAlerts && <PriceDropsAlertsSection propertyData={propertyData} isPolygonSearch={searchQuery?.withPolygon && hasPolygonData} mutate={() => mutate?.()} />}

        {/* only show sort button on desktop screen */}
        <div className='hidden w-fit items-center gap-4 lg2:flex'>
          <SortButton data-sentry-element="SortButton" data-sentry-source-file="SearchResultMessageAndSortFilter.tsx" />
        </div>
      </div>
      {!isTheseNearByProperties && <div className='disable_click'>
          {/** When there is no properties in searched location and we remove the boundary automatically, we need to show a different message indicating that the properties are of nearby locations.*/}
          {isBoundaryAutoRemoved && !isPropertiesLoading && locationName !== MAP_AREA && <h1 className='text-sm font-medium leading-normal text-secondary1000 md:text-base'>
                {`Here ${count === 1 ? "is" : "are"} ${count} stay${count === 1 ? "" : "s"} nearby.`}
              </h1> || null}
        </div>}
    </>;
};
export default SearchResultMessageAndSortFilter;